export const USER_STATUS_ACTIVE = 'active';
export const USER_STATUS_INACTIVE = 'inactive';
export const USER_STATUS_INV_SENT = 'invitation_sent';
export const USER_STATUS_INV_DECLINED = 'invitation_declined';
